import moment from 'moment-timezone';
import preferences from '@/services/api/compte/preferences';
import { userConsentObservation } from '@/helpers/ConsentHelpers';
import api from '@/services/api';

const getDefaultState = () => {
  return {
    preferences: {},
  };
};

const state = getDefaultState();

const categories = {
  mas: 'machines-a-sous',
  casinoendirect: 'casino-en-direct',
  keno: 'keno',
  loteries: 'loteries',
  sportsvirtuels: 'sports-virtuels',
  instants: 'instants',
  table: 'jeux-de-table',
};

const getters = {
  // TODO: Éviter la duplication de code
  isJoueRecemment: (state) => (produit) => {
    const cle = 'recents';
    const cleProduit = `${produit.name}__${categories[produit.categorie]}`;
    return state.preferences[cle]?.find((element) => element.idJeu == cleProduit) != undefined;
  },
  isFavori: (state) => (produit) => {
    const cle = 'favoris';
    const cleProduit = `${produit.name}__${categories[produit.categorie]}`;
    return state.preferences[cle]?.find((element) => element.idJeu == cleProduit) != undefined;
  },
  dateHeureJoueRecemment: (state) => (produit) => {
    const cle = 'recents';
    const cleProduit = `${produit.name}__${categories[produit.categorie]}`;
    const trouve = state.preferences[cle]?.find((element) => element.idJeu == cleProduit);
    return trouve ? trouve.dateTime : null;
  },
  dateHeureFavori: (state) => (produit) => {
    const cle = 'favoris';
    const cleProduit = `${produit.name}__${categories[produit.categorie]}`;
    const trouve = state.preferences[cle]?.find((element) => element.idJeu == cleProduit);
    return trouve ? trouve.dateTime : null;
  },
};

const actions = {
  reset({ commit }) {
    commit('RESET');
  },
  // Retourne préférences du store sinon du service
  async getPreferences({ state, commit }) {
    userConsentObservation(process.env.VUE_APP_IAB_ID_PREFERENCE, function () {
      // On retourne le contenu du store
      if (state.preferences && state.preferences.length > 0) {
        return state.preferences;
      }

      return api
        .call('ce-intpref/v2/players/preferences', 'getPlayersPreferences', 'GET', {
          withCredentials: true,
        })
        .then((response) => {
          commit('SET_PREFERENCES', response.data?.preferences);
          return response.data?.preferences;
        })
        .catch((error) => {
          throw error;
        });
    });
  },

  async setPreferenceJoueRecemment({ state, commit }, produit) {
    userConsentObservation(process.env.VUE_APP_IAB_ID_PREFERENCE, function () {
      const cleProduit = `${produit.name}__${categories[produit.categorie]}`;

      if (!state.preferences.recents) {
        api
          .call('ce-intpref/v2/players/preferences', 'getPlayersPreferences', 'GET', {
            withCredentials: true,
          })
          .then((response) => {
            commit('SET_PREFERENCES', response.data?.preferences);
            // https://lotoquebec.atlassian.net/browse/NAVCAT-564
            // TODO: Si le "dernier joué" est le même que celui qu'on souhaite sauvegarder, ne pas sauvegarder inutilement
            preferences.sauvegarderPreferenceJoueRecemment(cleProduit);
          });
      } else preferences.sauvegarderPreferenceJoueRecemment(cleProduit);
    });
  },
  async togglePreferenceFavori({ state, commit }, { produit, isToggledApresConnexion }) {
    userConsentObservation(process.env.VUE_APP_IAB_ID_PREFERENCE, async function () {
      const cleProduit = `${produit.name}__${categories[produit.categorie]}`;
      const isAjoutFavori = false;
      const cle = 'favoris';

      const preference = {};
      preference.idJeu = cleProduit;
      preference.dateTime = moment().utc().format();

      if (!state.preferences.favoris) {
        api
          .call('ce-intpref/v2/players/preferences', 'getPlayersPreferences', 'GET', {
            withCredentials: true,
          })
          .then(async (response) => {
            commit('SET_PREFERENCES', response.data?.preferences);

            // https://lotoquebec.atlassian.net/browse/NAVCAT-565
            if (
              state.preferences[cle] &&
              state.preferences[cle].find((element) => element.idJeu == cleProduit)
            ) {
              // On ne retire pas le produit si le toggle viens apres connexion
              if (!isToggledApresConnexion) {
                commit('DEL_PREFERENCE_FAVORI', cleProduit);
                preferences.supprimerPreferenceFavori(cleProduit);
              }
            } else {
              commit('SET_PREFERENCE_FAVORI', preference);
              preferences.sauvegarderPreferenceFavori(cleProduit);
            }
          });
        // https://lotoquebec.atlassian.net/browse/NAVCAT-565
      } else if (state.preferences[cle].find((element) => element.idJeu == cleProduit)) {
        // On ne retire pas le produit si le toggle viens apres connexion
        if (!isToggledApresConnexion) {
          commit('DEL_PREFERENCE_FAVORI', cleProduit);
          preferences.supprimerPreferenceFavori(cleProduit);
        }
      } else {
        commit('SET_PREFERENCE_FAVORI', preference);
        preferences.sauvegarderPreferenceFavori(cleProduit);
      }
    });
  },
};
/*
function sortPreferences(preferences) {
  return preferences.sort((a, b) => {
    return new Date(b.dateTime) - new Date(a.dateTime);
  });
}
*/
const mutations = {
  RESET(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState());
  },
  // Mettre à jour TOUTES les préférences
  SET_PREFERENCES(state, preferences) {
    if (typeof preferences !== 'undefined' && preferences !== null) {
      Object.keys(preferences).map((key, index) => {
        if (key === 'recents' || key === 'favoris') {
          state.preferences = { ...state.preferences, [key]: [] };
          state.preferences[key] = preferences[key];
        }
        return true;
      });
    }
  },
  // Ajouter le produit à préférence "favoris"
  // Choix conscient de code dupliqué de "recents" ci-après (à améliorer)
  SET_PREFERENCE_FAVORI(state, preference) {
    const cle = 'favoris';

    if (!state.preferences[cle]) {
      // Forcer la réactivité avec l'opérateur "spread"
      state.preferences = { ...state.preferences, [cle]: [] };
    }

    // Ajouter le produit en début de liste
    state.preferences[cle].unshift(preference);
  },

  DEL_PREFERENCE_FAVORI(state, cleProduit) {
    const cle = 'favoris';
    // Retirer le produit si déjà existant
    state.preferences[cle] = state.preferences[cle].filter((element) => {
      return element.idJeu != cleProduit;
    });
  },

  // Ajouter le produit à préférence "recents"
  // TODO: Éviter la duplication de code
  SET_PREFERENCE_JOUE_RECEMMENT(state, preference) {
    const cle = 'recents';

    if (!state.preferences[cle]) {
      // Forcer la réactivité avec l'opérateur "spread"
      state.preferences = { ...state.preferences, [cle]: [] };
    }
    // Retirer le produit si déjà existant
    state.preferences[cle] = state.preferences[cle].filter((entree) => {
      return entree.idJeu != preference.idJeu;
    });
    state.preferences[cle].unshift(preference);
  },

  // Mettre à jour une seule préférence
  SET_PREFERENCE(state, propriete, valeur) {
    state.preferences[propriete] = valeur;
  },
  RESET_PREFERENCES(state) {
    state.preferences = null;
  },
  EMPTY_PREFERENCES(state) {
    state.preferences = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
